import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              <i className="ri-chat-1-line text-primary-500 mr-2"></i>
              网友热评
            </h2>
            <p className="text-foreground-500 text-sm">来看看其他瓜友们怎么说</p>
          </div>
          <div className="space-y-4">
            {commentItems.map((item, idx) => (
              <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-500 rounded-full font-bold text-sm flex-shrink-0">
                    {item.avatar}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-2">
                      <span className="text-sm font-medium text-foreground-800">{item.name}</span>
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-500 ml-auto">{item.time}</span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                      {item.content}
                    </p>
                    <div className="flex items-center gap-1 text-foreground-500">
                      <span className="w-5 h-5 flex items-center justify-center cursor-pointer">
                        <i className="ri-thumb-up-line text-sm"></i>
                      </span>
                      <span className="text-xs">{item.likes}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-6 py-2.5 border-2 border-primary-200 text-primary-600 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer no-underline"
            >
              <i className="ri-edit-line"></i>
              我也要评论
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}